<template>
  <div>
    <vx-card v-show="showCampaignSelect">
      <div class="text-center pb-8">
        <h4 class="pb-2">Choose Campaign For Cascading Fields</h4>
      </div>
      <div class="mb-8">
        <div class="vx-row mb-6">
          <div class="vx-col sm:w-1/6 w-full">
            <span>Campaign:</span>
          </div>
          <div class="vx-col sm:w-1/2 w-full">
            <CampaignAutocomplete
              :key="companySearchComponentKey"
              class="searchbox"
              :list="searchCampaign"
              :searchOn="'campaign'"
              @event-name="handleChildEvent"
            ></CampaignAutocomplete>
            <span class="text-danger text-sm mt-5" v-show="campaign_required"
              >{{ campaign_required }}
            </span>
          </div>
        </div>
        <div class="center-span">
          <vs-button class="mt-10" @click.prevent="submitCampaign"
            >Submit</vs-button
          >
        </div>
      </div>
    </vx-card>
    <vx-card
      title="Now You Need To Select Fields For Cascade"
      class="mt-5"
      v-if="showFieldSelection"
    >
      <p>
        On the left are the source fields. On the right are the fields for
        cascade.
      </p>

      <div class="flex">
        <div class="w-1/5 bg-grid-color-secondary">
          <vs-list>
            <vs-list-header
              title="Field Types"
              color="primary"
            ></vs-list-header>
            <template v-for="(slot, index) in sourceFieldgroups">
              <div style="height: 100px;">
                <v-select
              @input="getSourceFieldIndex(event,index)"
                ref="source_field_select"
                label="label"
                class="pb-15 pt-15"
                :options="source_field_types"
                v-model="slot.sourceFieldType"
                
              />
              </div>
             
            </template>
          </vs-list>
        </div>
        <!-- <div class="w-1/5 bg-grid-color">
          <vs-list>
            <vs-list-header
              title="Client"
              color="primary"
            ></vs-list-header>
            <template v-for="(slot, index) in sourceFieldgroups">
              <v-select
                label="label"
                class="pb-15 pt-15"
                :options="source_client_types"
                :key="index"
                v-model="slot.sourceFieldType"
                
              />
            </template>
          </vs-list>
        </div> -->
        <div class="w-1/3 bg-grid-color-secondary">
          <vs-list>
            <vs-list-header title=" Fields" color="primary"></vs-list-header>
            <template v-for="(slot, index) in sourceFieldgroups">
              <div style="height: 100px;">

              <div class="vx-row" :key="index">
                <div class="vx-col w-full md:w-4/5">
                  <multiselect
                    v-model="slot.sourceField"
                    :options="source_options"
                    :multiple="false"
                    group-values="column_names"
                    group-label="group"
                    :group-select="false"
                    placeholder="Type to search"
                    track-by="name"
                    label="label"
                    
                  >
                    <span slot="noResult"
                      >Oops! No elements found. Consider changing the search
                      query.</span
                    >
                  </multiselect>
                </div>
                <div class="vx-col w-full md:w-1/6">
                  <vs-button
                    color="primary"
                    :key="index + 1"
                    @click="deleteSourceColumn(slot)"
                    type="line"
                    icon-pack="feather"
                    icon="icon-trash"
                  ></vs-button>
                </div>
              </div>
              </div>
            </template>

            <span class="text-danger text-sm mb-10">{{
              validation_message
            }}</span>
          </vs-list>
          <vs-button
            color="primary"
            @click="addSourceColumn()"
            type="line"
            icon-pack="feather"
            icon="icon-plus"
          ></vs-button>
        </div>
        <div class="w-1/5 bg-grid-color">
          <vs-list>
            <vs-list-header
              title="Field Types"
              color="primary"
            ></vs-list-header>
            <template v-for="(slot, index) in triggerFieldgroups">
              <div style="height: 100px;">

              <v-select
              @input="getTriggerFieldIndex(event,index)"
                ref="trigger_field_select"
                label="label"
                class="pb-15 pt-15"
                :options="trigger_field_types"
                :key="index"
                v-model="slot.triggerFieldType"
                
              />
              </div>
            </template>
          </vs-list>
        </div>
        <div class="w-1/3 bg-grid-color-secondary">
          <vs-list>
            <vs-list-header title=" Fields" color="primary"></vs-list-header>
            <template v-for="(slot, index) in triggerFieldgroups">
              <div style="height: 100px;">

              <div class="vx-row" :key="index">
                <div class="vx-col w-full md:w-4/5">
                  <multiselect
                    v-model="slot.triggerField"
                    :options="trigger_options"
                    :multiple="false"
                    group-values="column_names"
                    group-label="group"
                    :group-select="false"
                    placeholder="Type to search"
                    track-by="name"
                    label="label"
                    
                  >
                    <span slot="noResult"
                      >Oops! No elements found. Consider changing the search
                      query.</span
                    >
                  </multiselect>
                </div>
                <div class="vx-col w-full md:w-1/6">
                  <vs-button
                    color="primary"
                    :key="index + 1"
                    @click="deleteTriggerColumn(slot)"
                    type="line"
                    icon-pack="feather"
                    icon="icon-trash"
                  ></vs-button>
                </div>
              </div>
              </div>
            </template>
          </vs-list>
          <vs-button
            color="primary"
            @click="addTriggerColumn()"
            type="line"
            icon-pack="feather"
            icon="icon-plus"
          ></vs-button>
        </div>
      </div>
      <div class="text-right">
        <vs-button
        @click="submitSelectedFields"
        color="primary"
        type="filled"
        >Submit</vs-button
      >
      </div>
    
    </vx-card>
  </div>
</template>

<script>
import moduleCampaignManagement from "@/store/campaign-management/moduleCampaignManagement.js";
import CampaignAutocomplete from "@/components/autocomplete/CampaignAutocomplete.vue";
import ClientAutocomplete from "@/components/autocomplete/ClientsAutocomplete.vue";
import moduleClientManagement from "@/store/clients-management/moduleClientsManagement.js";
import defineAbilitiesFor from "@/config/abilities";
import ImportExcel from "@/components/excel/ImportExcel.vue";
import Prism from "vue-prism-component";
import vSelect from "vue-select";
import axios from "@/axios.js";
import _ from "lodash";
import Multiselect from "vue-multiselect";
// import MatchResults from "@/components/Match.vue"
export default {
  components: {
    ImportExcel,
    Prism,
    vSelect,
    CampaignAutocomplete,
    ClientAutocomplete,
    Multiselect
  },
  data() {
    return {
      source_field_select_index:null,
      selected_client: null,
      new_csv_field_name: null,
      addNewColumnToCsvTablePopUp: false,
      temporary_csv_columns: [],
      campaign_required: null,
      selected_campaign: [],
      user_id: null,
      user_role: null,
      companySearchComponentKey: 0,
      master_fields: [],
      client_fields: [],
      campaign_fields: [],
      csv_table_columns: [],
      selected_db_fields: [],
      abilities: null,
      table_name_exists: null,
      upload_validation: false,
      upload_validation_message: null,
      file_name: null,
      table_name: null,
      csv_filename: null,
      validation_message: "",
      sourceFieldgroups: [
        {
          sourceFieldType: "",
          sourceField: ""
        }
      ],
      triggerFieldgroups: [
        {
          triggerFieldType: "",
          triggerField: ""
        }
      ],
      temp_campaign_accounts_columns: [],
      showFieldSelection: false,
      showCampaignSelect: true,
      tableData: [],
      header: [],
      sheetName: "",
      campaign_clients: [],
      source_field_types: [
        {
          id: 1,
          name: "master_field",
          value: "master_field",
          label: "Master Field"
        },
        {
          id: 2,
          name: "client_field",
          value: "client_field",
          label: "Client Field"
        },
        {
          id: 3,
          name: "campaign_field",
          value: "campaign_field",
          label: "Campaign Field"
        }
      ],
      trigger_field_types: [
        {
          id: 1,
          name: "master_field",
          value: "master_field",
          label: "Master Field"
        },
        {
          id: 2,
          name: "client_field",
          value: "client_field",
          label: "Client Field"
        },
        {
          id: 3,
          name: "campaign_field",
          value: "campaign_field",
          label: "Campaign Field"
        }
      ],
      uploaded_columns: [],
      source_options: [],
      trigger_options: [],
      triggger_field_type: null,
      source_field_type: null
    };
  },
  computed: {
    sourceFieldType() {
      return this.sourceFieldgroups.map(slot => slot.sourceFieldType);
    },
    triggerFieldType() {
      return this.triggerFieldgroups.map(slot => slot.triggerFieldType);
    }
  },
  mounted() {},
  watch: {
    sourceFieldType(val) {
      this.source_options = [];
      let source_field_type = val[val.length - 1];

      if (source_field_type.name == "master_field") {
        this.getSourceMasterFields();
      }

      if (source_field_type.client) {
        this.getSourceClientFields(source_field_type.id);
      }

      if (source_field_type.name == "client_field") {
        this.getSourceCampaignClients();
      }

      if (source_field_type.name == "campaign_field") {
        this.getSourceCampaignFields();
      }
    },
    triggerFieldType(val) {
      this.trigger_options = [];
      let trigger_field_type = val[val.length - 1];
      console.log(trigger_field_type.name);
      if (trigger_field_type.name == "master_field") {
        this.getTriggerMasterFields();
      }

      if (trigger_field_type.name == "client_field") {
        this.getTriggerCampaignClients();
      }
      if (trigger_field_type.client) {
        this.getTriggerClientFields(trigger_field_type.id);
      }

      if (trigger_field_type.name == "campaign_field") {
        this.getTriggerCampaignFields();
      }
    }
  },
  methods: {
    getSourceFieldIndex(event,index) {
      this.source_field_select_index = index
    },
    getTriggerFieldIndex(event,index) {
      this.trigger_field_select_index = index
    },
    handleChildEvent() {
      let self = this;
      let result = moduleCampaignManagement.state.campaign.datas;
      self.selected_campaign = result[0];
      self.showFieldSelection = true;
      self.showCampaignSelect = false;
    },
    searchCampaign(inputValue) {
      let filter = {};
      filter.search_term = inputValue;
      filter.user_role = this.user_role;
      filter.user_id = this.user_id;
      return this.$store
        .dispatch("campaignsManagement/searchCampaign", filter)
        .then(response => {
          if (response) {
            let data = moduleCampaignManagement.state.campaign;
            if (data) {
              // console.log(data);
              let mappedArray = [];
              for (const property in data) {
                if (typeof data[property].campaign_name != "undefined") {
                  mappedArray.push({
                    id: data[property].id,
                    name:
                      data[property].campaign_name +
                      "  -   " +
                      data[property].campaign_code,
                    type: "campaign"
                  });
                }
              }
              return mappedArray;
            }
          }
        })
        .catch(err => {
             if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    },
    addAnother: function() {
      this.sourceFieldgroups.push({
        sourceFieldType: "",
        sourceField: ""
      });
      this.triggerFieldgroups.push({
        triggerFieldType: "",
        triggerField: ""
      });
    },
    addSourceColumn() {
      this.sourceFieldgroups.push({
        sourceFieldType: "",
        sourceField: ""
      });

      this.source_field_types = [
        {
          id: 1,
          name: "master_field",
          value: "master_field",
          label: "Master Field"
        },
        {
          id: 2,
          name: "client_field",
          value: "client_field",
          label: "Client Field"
        },
        {
          id: 3,
          name: "campaign_field",
          value: "campaign_field",
          label: "Campaign Field"
        }
      ];
    },
    addTriggerColumn() {
      this.triggerFieldgroups.push({
        triggerFieldType: "",
        triggerField: ""
      });

      this.trigger_field_types = [
        {
          id: 1,
          name: "master_field",
          value: "master_field",
          label: "Master Field"
        },
        {
          id: 2,
          name: "client_field",
          value: "client_field",
          label: "Client Field"
        },
        {
          id: 3,
          name: "campaign_field",
          value: "campaign_field",
          label: "Campaign Field"
        }
      ];
    },
    deleteSourceColumn(slot) {
      this.sourceFieldgroups = this.sourceFieldgroups.filter(function(ele) {
        return ele != slot;
      });

      this.source_field_types = [
        {
          id: 1,
          name: "master_field",
          value: "master_field",
          label: "Master Field"
        },
        {
          id: 2,
          name: "client_field",
          value: "client_field",
          label: "Client Field"
        },
        {
          id: 3,
          name: "campaign_field",
          value: "campaign_field",
          label: "Campaign Field"
        }
      ];
      // this.triggerFieldgroups = this.triggerFieldgroups.filter(function(ele) {
      //   return ele != slot;
      // });
      // this.fieldgroups.pop(slot);
    },
    deleteTriggerColumn(slot) {
      // this.sourceFieldgroups = this.sourceFieldgroups.filter(function(ele) {
      //   return ele != slot;
      // });
      this.triggerFieldgroups = this.triggerFieldgroups.filter(function(ele) {
        return ele != slot;
      });

      this.trigger_field_types = [
        {
          id: 1,
          name: "master_field",
          value: "master_field",
          label: "Master Field"
        },
        {
          id: 2,
          name: "client_field",
          value: "client_field",
          label: "Client Field"
        },
        {
          id: 3,
          name: "campaign_field",
          value: "campaign_field",
          label: "Campaign Field"
        }
      ];
      // this.fieldgroups.pop(slot);
    },
    submitCampaign() {
      self.showFieldSelection = true;
      self.showCampaignSelect = false;
    },
    getSourceMasterFields() {
      this.$store
        .dispatch("campaignsManagement/getAllMasterFields")
        .then(response => {
          this.master_fields = response.data;

          this.master_fields.forEach(function(ele, index) {
            ele.label = ele.name;
            ele.field_type = "master_fields";
            ele.group = "Master Fields";
            let ele_name = ele.name;
            ele.name = ele_name.replace(/[^a-zA-Z0-9]/g, "_").toLowerCase();
            ele.value = ele.name;
          });

          let masterField = {
            group: "Master Fields",
            column_names: this.master_fields
          };

          this.source_options.push(masterField);
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
    }
  })
    },
    getSourceClientFields(client_id) {
      let self = this;
      let data = {};
      data.selected_campaign_id = self.selected_campaign.id;
      data.client_id = client_id;
      self.$store
        .dispatch("campaignsManagement/fetchClientFieldsByClientId", data)
        .then(response => {
          if (response) {
            self.client_fields = JSON.parse(response.data);

            self.client_fields.forEach(function(ele, index) {
              ele.label = ele.name;
              ele.group = ele.client_name;
              let ele_name = ele.name;
              ele.name = ele_name.replace(/[^a-zA-Z0-9]/g, "_").toLowerCase();
              ele.value = ele.name;
            });

            let clientField = {
              group: "Client Fields",
              column_names: self.client_fields
            };

            self.source_options.push(clientField);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    getSourceCampaignClients() {
      let self = this;
      let selected_campaign_id = self.selected_campaign.id;
      self.$store
        .dispatch(
          "campaignsManagement/fetchCampaignClients",
          selected_campaign_id
        )
        .then(response => {
          if (response) {
            self.campaign_clients = JSON.parse(response.data);

            self.campaign_clients.forEach(function(ele) {
              ele.id = ele.client_id;
              ele.name = ele.company_name;
              ele.value = ele.company_name;
              ele.label = ' ➤ '  + ele.company_name;
              ele.client = true;
            });




     


            self.source_field_types = self.campaign_clients;



            let all_fields = [
        {
          id: 1,
          name: "master_field",
          value: "master_field",
          label: "Master Field"
        },
        {
          id: 3,
          name: "campaign_field",
          value: "campaign_field",
          label: "Campaign Field"
        }
      ];
            all_fields.forEach(arr => {
        self.source_field_types.push(arr)
      })



self.$refs.source_field_select[self.source_field_select_index].open = true

      // self.source_field_select.click()




      

          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    getTriggerCampaignClients() {
      let self = this;
      let selected_campaign_id = self.selected_campaign.id;
      self.$store
        .dispatch(
          "campaignsManagement/fetchCampaignClients",
          selected_campaign_id
        )
        .then(response => {
          if (response) {
            self.campaign_clients = JSON.parse(response.data);

            self.campaign_clients.forEach(function(ele) {
              ele.id = ele.client_id;
              ele.name = ele.company_name;
              ele.value = ele.company_name;
              ele.label = ' ➤ '  + ele.company_name;
              ele.client = true;
            });
            self.trigger_field_types = self.campaign_clients;



            let all_fields = [
        {
          id: 1,
          name: "master_field",
          value: "master_field",
          label: "Master Field"
        },
        {
          id: 3,
          name: "campaign_field",
          value: "campaign_field",
          label: "Campaign Field"
        }
      ];
            all_fields.forEach(arr => {
        self.trigger_field_types.push(arr)
      })


      self.$refs.trigger_field_select[self.trigger_field_select_index].open = true




          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    getSourceCampaignFields() {
      let self = this;
      let selected_campaign_id = self.selected_campaign.id;
      this.$store
        .dispatch(
          "campaignsManagement/fetchCampaignFields",
          selected_campaign_id
        )
        .then(response => {
          if (response) {
            this.campaign_fields = response.data;

            this.campaign_fields.forEach(function(ele, index) {
              ele.label = ele.name;
              ele.group = "Campaign Fields";
              ele.field_type = "campaign_fields";
              let ele_name = ele.name;
              ele.name = ele_name.replace(/[^a-zA-Z0-9]/g, "_").toLowerCase();
              ele.value = ele.name;
            });

            let campaignField = {
              group: "Campaign Fields",
              column_names: this.campaign_fields
            };

            this.source_options.push(campaignField);
          }
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.campaign_fields = [];
            return;
          }
          console.error(err);
        });
    },
    getTriggerMasterFields() {
      this.$store
        .dispatch("campaignsManagement/getAllMasterFields")
        .then(response => {
          this.master_fields = response.data;

          this.master_fields.forEach(function(ele, index) {
            ele.label = ele.name;
            ele.group = "Master Fields";
            let ele_name = ele.name;
            ele.field_type = "master_fields";
            ele.name = ele_name.replace(/[^a-zA-Z0-9]/g, "_").toLowerCase();
            ele.value = ele.name;
          });

          let masterField = {
            group: "Master Fields",
            column_names: this.master_fields
          };

          this.trigger_options.push(masterField);
        })
        .catch(err => {
          if (err.response.status === 401) {
            this.$router.replace("/login");
    }
  })
    },
    getTriggerClientFields(client_id) {
      let self = this;
      let data = {};
      data.selected_campaign_id = self.selected_campaign.id;
      data.client_id = client_id;
      self.$store
        .dispatch("campaignsManagement/fetchClientFieldsByClientId", data)
        .then(response => {
          if (response) {
            self.client_fields = JSON.parse(response.data);

            self.client_fields.forEach(function(ele, index) {
              ele.label = ele.name;
              ele.group = ele.client_name;
              let ele_name = ele.name;
              ele.name = ele_name.replace(/[^a-zA-Z0-9]/g, "_").toLowerCase();
              ele.value = ele.name;
            });

            let clientField = {
              group: "Client Fields",
              column_names: self.client_fields
            };

            self.trigger_options.push(clientField);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    getTriggerCampaignFields() {
      let self = this;
      let selected_campaign_id = self.selected_campaign.id;
      this.$store
        .dispatch(
          "campaignsManagement/fetchCampaignFields",
          selected_campaign_id
        )
        .then(response => {
          if (response) {
            this.campaign_fields = response.data;

            this.campaign_fields.forEach(function(ele, index) {
              ele.label = ele.name;
              ele.group = "Campaign Fields";
              ele.field_type = "campaign_fields";
              let ele_name = ele.name;
              ele.name = ele_name.replace(/[^a-zA-Z0-9]/g, "_").toLowerCase();
              ele.value = ele.name;
            });

            let campaignField = {
              group: "Campaign Fields",
              column_names: this.campaign_fields
            };

            this.trigger_options.push(campaignField);
          }
        })
        .catch(err => {
          if (err.response.status === 404) {
            this.campaign_fields = [];
            return;
          }
          console.error(err);
        });
    },
    submitSelectedFields() {
      let self = this;
      var mergedFieldGroups = [];
      for (var i = 0; i < self.sourceFieldgroups.length; i += 1) {
        let item = {};
        item.sourceField = self.sourceFieldgroups[i].sourceField;
        item.triggerField = self.triggerFieldgroups[i].triggerField;
        mergedFieldGroups.push(item);
      }
      mergedFieldGroups[0].campaign = this.selected_campaign;

      mergedFieldGroups.forEach(function(ele) {
        if (ele.sourceField.id == ele.triggerField.id) {
          self.$vs.notify({
            color: "danger",
            title: "Cascade Fields",
            text:
              "Cannot choose a same field type for trigger.Please correct it and click on proceed."
          });
          mergedFieldGroups = [];
          return false;
        }
      });

      self.$store
        .dispatch("campaignsManagement/addCascadeFields", mergedFieldGroups)
        .then(res => {
          if (res.data.status == "success") {
            self.$vs.notify({
              color: "success",
              title: "Cascade Fields",
              text: res.data.message
            });
            self.$router.push({ path: "/campaigns/list-cascade-fields" });
          }
        })
        .catch(err => {
          console.log(err);

                       if (err.response.status === 401) {
            this.$router.replace("/login");
    }
        });
    }
  },
  created() {
    let userInfo = JSON.parse(localStorage.getItem("userInfo"));
    this.user_id = userInfo["uid"];
    this.user_role = userInfo["userRole"];
    var self = this;
    defineAbilitiesFor().then(function(data) {
      self.abilities = data;
    });

    if (!moduleCampaignManagement.isRegistered) {
      this.$store.registerModule(
        "campaignsManagement",
        moduleCampaignManagement
      );
      moduleCampaignManagement.isRegistered = true;
    }
    if (!moduleClientManagement.isRegistered) {
      this.$store.registerModule("clientsManagement", moduleClientManagement);
      moduleClientManagement.isRegistered = true;
    }
  }
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.vs-table--tbody-table tr {
  -webkit-transition: none;
  transition: none;
  background: #fff;
}

.vs-table--tbody-table
  .tr-values:not(.activeEdit):not(.tr-expandedx):not(.hoverFlat):hover {
  -webkit-transform: none;
  transform: none;
}

.center-span {
  text-align: center;
  margin-left: auto;
  margin-right: auto;
}
</style>
